import { render, staticRenderFns } from "./OrganisationMembershipForm.vue?vue&type=template&id=6942c2bb&scoped=true&"
import script from "./OrganisationMembershipForm.vue?vue&type=script&lang=js&"
export * from "./OrganisationMembershipForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6942c2bb",
  null
  
)

export default component.exports